export default __webpack_public_path__ + "static/media/Celeste_CloudBack.1aa72570.png";